module.exports = {
    'en': {
        'odds_company': 'Company',
        'odds_dc': 'Detail Changes',
        'odds_initial': 'Initial'
    },
    'zh_cn': {
        'odds_company': 'zh_Company',
        'odds_dc': 'zh_Detail Changes',
        'odds_initial': 'zh_Initial'
    },
    'es': {
        'odds_company': 'Empresa',
        'odds_dc': 'El detalle cambia',
        'odds_initial': 'Inicial'
    },
    'pt': {
        'odds_company': 'Empresa',
        'odds_dc': 'Mudança de detalhes',
        'odds_initial': 'Inicial'
    },
    'it': {
        'odds_company': 'Società',
        'odds_dc': 'Cambiamenti Dettagli',
        'odds_initial': 'Iniziale'
    },
    'fr': {
        'odds_company': 'Compagnie',
        'odds_dc': 'Modifications de détails',
        'odds_initial': 'Initial'
    },
    'ru': {
        'odds_company': 'Компания',
        'odds_dc': 'Подробные изменения',
        'odds_initial': 'Начальный'
    },
    'tr': {
        'odds_company': '',
        'odds_dc': '',
        'odds_initial': ''
    },
    'in': {
        'odds_company': 'Perusahaan',
        'odds_dc': 'Perubahan Detail',
        'odds_initial': 'Awal'
    },
    'th': {
        'odds_company': 'บริษัท',
        'odds_dc': 'การเปลี่ยนแปลงรายละเอียด',
        'odds_initial': 'เริ่มต้น'
    },
    'de': {
        'odds_company': 'Unternehmen',
        'odds_dc': 'Detailänderungen',
        'odds_initial': 'Start'
    },
    'id': {
        'odds_company': 'Perusahaan',
        'odds_dc': 'Perubahan Detail',
        'odds_initial': 'Awal'
    },
    'ja': {
        'odds_company': '会社',
        'odds_dc': '詳細変更内容',
        'odds_initial': 'イニシャル'
    },
    'vi': {
        'odds_company': 'Công ty',
        'odds_dc': 'Thay đổi chi tiết',
        'odds_initial': 'Ban đầu'
    },
    'ar': {
        'odds_company': 'شركة',
        'odds_dc': 'تغييرات التفاصيل',
        'odds_initial': 'أولي'
    }
};



// WEBPACK FOOTER //
// ./src/lang/oddsChanges.js